import styled from 'styled-components'
import { theme } from '../../../../../styles/theme'

export const Container = styled.div`
  & > h2 {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: ${theme.colors.brown};
    margin-bottom: 40px;
  }
`

export const ButtonWrapper = styled.div`
  /* display: grid;
  grid-template-columns: repeat(2, 1fr); */
  /* gap: 20px; */
`

export const Button = styled.div`
  padding: 12px;
  border-radius: 8px;
  background: ${theme.colors.orange};
  box-shadow: 0px 6px 15px 0px rgba(37, 42, 49, 0.10);
  color: ${theme.colors.white};
  text-align: center;

  cursor: pointer;
  
  transition: filter 0.2s ease-in-out;

  &:hover {
    filter: brightness(0.9);
  }

  &:last-child {
    /* background: ${theme.colors.brown}; */
  }
`
